module.exports = __webpack_public_path__ + "static/media/zoomOut.95ab2336.svg";